module.exports = __webpack_public_path__ + "img/ornament.e9214454.svg";